import {useRef, useState} from "react";
import {Tooltip, useOutsideClick} from "@chakra-ui/react";
import {InfoIcon} from "@chakra-ui/icons";

export const FormItemTitle = ({title, label, required, isLabel}) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useOutsideClick({
    ref: ref,
    handler: () => {
      if(isOpen){
        setIsOpen(false);
      }
    },
  });

  const displayTooltip = () => {
    if(!label) {
      return;
    }
    setIsOpen(!isOpen);
  }

  return (
    <div onClick={displayTooltip} className={`flex items-center ${title && 'pb-2'} gap-1`} ref={ref}>
      <h3 className={`${isLabel ? 'font-normal text-brand-text' : 'text-lg font-bold text-slate-600 '}  flex items-center`}>
        {title}
        {required && (
          <p className="text-red-500 superscript text-sm pl-1">*</p>
        )}
      </h3>
      {label && (
        <Tooltip
          hasArrow
          label={label}
          isOpen={isOpen}
          className='cursor-pointer'
        >
          <InfoIcon className='cursor-pointer hover:text-blue-400 transition' color="blue.200" marginLeft="4px"/>
        </Tooltip>
      )}
    </div>
  )
}
